import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, CardHeader, Grid, Grid2 } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { historiqueService } from "../service/HistoriqueService";
import { RefreshOutlined } from "@material-ui/icons";
import useToast from "../hooks/useToast";
import { TYPE_NOTIFICATION } from "./utils/NotificationBull";
import { LoadingButton } from "@mui/lab";
import { frFR } from "@mui/x-data-grid/locales";
import dayjs from "dayjs";
import Menu from "./Menu";

const HistoriqueDeDemande = ({ prec_url }) => {
  const ref_user = localStorage.getItem("ref");
  const { Toast, showToast } = useToast();
  const [idsButons, setIdsButons] = useState([]);
  const [rows, setRows] = useState([]);

  const columns = [
    { field: "ami", headerName: "AMI", width: 250 },
    { field: "titre", headerName: "Titre", width: 500 },
    {
      field: "Date_creation",
      headerName: "Date d'envoie",
      width: 200,
      valueFormatter: (params) =>
        dayjs(params.value).format("DD/MM/YYYY à hh : mm"),
    },
    {
      field: "file_cv",
      headerName: "CV Utilisé",
      width: 200,
      renderCell: (params) => (
        <LoadingButton
          loading={idsButons.includes(params.row.id_identite)}
          disabled={!params.row.file_cv}
          title="Visualiser le CV"
          onClick={(e) =>
            handleDownload(params.row.id_identite, params.row.titre)
          }
        >
          Visualiser le CV
        </LoadingButton>
      ),
    },
  ];

  const handleLoadThisButton = (ids) => {
    setIdsButons([...idsButons, ids]);
  };

  const handleUnloadThisButton = (ids) => {
    setIdsButons(idsButons.filter((id) => id !== ids));
  };

  const handleFetchHistory = () => {
    historiqueService.getList(ref_user).then((res) => {
      if (res && res.data) {
        setRows(res.data);
      }
    });
  };

  const handleDownload = (ref, file_name) => {
    handleLoadThisButton(ref);
    historiqueService
      .downloadCV(ref)
      .then((res) => {
        if (res) {
          console.log(res);

          if (res.status !== 200) {
            showToast(TYPE_NOTIFICATION.ERROR, res.message);
            return;
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `CV_${file_name || new Date().toLocaleString()}.pdf`
            );
            document.body.appendChild(link);
            link.click();
          }
        }
      })
      .catch((e) => {
        showToast(TYPE_NOTIFICATION.ERROR, e.tosTring());
      })
      .finally(() => {
        handleUnloadThisButton(ref);
      });
  };

  useEffect(() => {
    handleFetchHistory();
  }, []);

  return (
    <>
      <Menu />
      <div
        style={{
          padding: "20px",
          borderRadius: "20px",
          borderColor: "#0747a1",
          borderStyle: "solid",
          borderWidth: "3px",
          height: "auto",
          width: "60vw",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "50px",
          marginBottom: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Grid item>
          <Toast />
          <Box height={"100%"}>
            <Grid
              item
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
            >
              <Grid textAlign={"center"} width={"100%"}>
                <CardHeader
                  title={"Historique de mes demandes"}
                  avatar={
                    <Button
                      title="Actualiser"
                      onClick={(e) => handleFetchHistory()}
                      //startIcon={<RefreshOutlined />}
                      variant="outlined"
                    >
                      <RefreshOutlined />
                    </Button>
                  }
                  titleTypographyProps={{
                    fontSize: {
                      xs: "1.25rem",
                      md: "1.35rem",
                      xl: "1.5rem",
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid2
              // p={{ xs: 1, lg: 5 }}
              maxWidth={"98vw"}
              height="60vh"
              flexGrow={1}
            >
              <DataGrid
                columns={columns}
                rows={rows}
                getRowId={(row) => row.reference}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                hideFooter
              />
            </Grid2>
          </Box>
        </Grid>
      </div>
    </>
  );
};

export default HistoriqueDeDemande;
